export const GET_RELATED_POSTS = "GET_RELATED_POSTS";
export const GET_RELATED_POSTS_SUCCESS = "GET_RELATED_POSTS_SUCCESS";
export const GET_RELATED_POSTS_ERROR = "GET_RELATED_POSTS_ERROR";
export const RESET_GET_RELATED_POSTS = "RESET_GET_RELATED_POSTS";

export interface RelatedPostItem {
  id: number;
  title: string;
  date: string;
  type: "video" | "pdf" | "audio" | "text";
  duration: string | null;
  thumbnail: string | null;
  seen: boolean;
  slug: string;
}

export interface RelatedPostsWindow {
  before: RelatedPostItem[];
  after: RelatedPostItem[];
}

export interface GetRelatedPostsPayload {
  post_id: number;
  category_id?: number;
  before?: number;
  after?: number;
}

export interface GetRelatedPosts {
  type: typeof GET_RELATED_POSTS;
  payload: GetRelatedPostsPayload;
}

export interface GetRelatedPostsSuccess {
  type: typeof GET_RELATED_POSTS_SUCCESS;
  payload: RelatedPostsWindow;
}

export interface GetRelatedPostsError {
  type: typeof GET_RELATED_POSTS_ERROR;
  payload: string | boolean;
}

export interface ResetGetRelatedPosts {
  type: typeof RESET_GET_RELATED_POSTS;
  payload: null;
}

export interface State {
  data: RelatedPostsWindow | null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions =
  | GetRelatedPosts
  | GetRelatedPostsSuccess
  | GetRelatedPostsError
  | ResetGetRelatedPosts;
